import { Box, IconButton } from "@chakra-ui/react";
import { IoMdAddCircle } from "react-icons/io";
import { MdDeleteOutline, MdModeEdit } from "react-icons/md";
import { Card } from "./Card";
import { THEME_COLOR_SCHEME } from "./theme";

interface ManageItemsWidgetProps {
  onNewItemClick: () => void;
  onEditClick?: () => void;
  onDeleteClick?: () => void;
  title?: string;
  children?: any;
}

export const ManageItemsWidget = ({
  onNewItemClick,
  onEditClick,
  onDeleteClick,
  title,
  children,
}: ManageItemsWidgetProps) => {
  return (
    <Card display={"flex"} marginBottom={4} alignItems={"center"} padding={4}>
      <Box fontSize={"large"} fontWeight={"bold"} width={"100%"}>
        {title}
      </Box>
      <Box display={"flex"} width={"100%"} justifyContent={"flex-end"}>
        {children}
        <IconButton
          onClick={onNewItemClick}
          colorScheme={THEME_COLOR_SCHEME}
          icon={<IoMdAddCircle />}
          aria-label={"create"}
          variant={"outline"}
        />
        {onEditClick ? (
          <IconButton
            marginLeft={2}
            variant={"outline"}
            colorScheme={THEME_COLOR_SCHEME}
            icon={<MdModeEdit />}
            aria-label={"edit"}
            onClick={onEditClick}
          />
        ) : null}
        {onDeleteClick ? (
          <IconButton
            marginLeft={2}
            colorScheme={"red"}
            icon={<MdDeleteOutline />}
            variant={"outline"}
            onClick={onDeleteClick}
            aria-label={"delete"}
          />
        ) : null}
      </Box>
    </Card>
  );
};
